export enum ScreenControlAliasOptionEnum {
    ONLY_ALIAS = 'only_alias',
    NO_ALIAS = 'no_alias',
    DYNAMIC_ALIAS = 'dynamic_alias',
}
export const DEFAULT_ALIAS_OPTION: ScreenControlAliasOptionEnum = ScreenControlAliasOptionEnum.DYNAMIC_ALIAS
